import { useContext } from 'react';
import type { AuthContextType as MsalAuthContextType } from 'src/contexts/auth/auth-context'; 
import { AuthContext } from 'src/contexts/auth/auth-context';

type AuthContextType =
  | MsalAuthContextType 

export const useNewAuth = <T = AuthContextType>() => useContext(AuthContext) as T;